function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1722 2.04444L2.04444 11.1722C2.09444 11.3611 2.19444 11.5333 2.32778 11.6722C2.46667 11.8056 2.63889 11.9056 2.82778 11.9556L11.9611 2.82778C11.8556 2.44444 11.5556 2.14444 11.1722 2.04444ZM6.93333 2L2 6.93333V8.50556L8.50556 2H6.93333ZM3.11111 2C2.5 2 2 2.5 2 3.11111V4.22222L4.22222 2H3.11111ZM10.8889 12C11.1944 12 11.4722 11.8778 11.6722 11.6722C11.8778 11.4722 12 11.1944 12 10.8889V9.77778L9.77778 12H10.8889ZM5.49444 12H7.06667L12 7.06667V5.49444L5.49444 12Z"
});

function SvgDiagonals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagonals);
export default __webpack_public_path__ + "static/media/diagonals.915b1c91.svg";
export { ForwardRef as ReactComponent };